export default __webpack_public_path__ + "static/media/fail_emerald.9e2f5bc5.png";